import React from "react";
import styled, { css } from "styled-components";
import { rem } from "polished";

const El = styled.div`
	color: #5a4a4a;
	font-size: ${rem(14)};
`;

const Stock = styled.span`
	font-weight: 700;

	${(props) =>
		props.uppercase &&
		css`
			text-transform: uppercase;
		`}

	${(props) =>
		props.inStock &&
		css`
			color: #3a9c38;
		`}

  ${(props) =>
		!props.inStock &&
		css`
			color: red;
		`}
`;

const StockStatus = ({ inStock = true, shippingInfo, uppercase = false }) => (
	<El>
		<Stock uppercase={uppercase} inStock={inStock}>
			{inStock ? "In stock" : "Out of stock"}
		</Stock>
		{inStock && shippingInfo && ` - ${shippingInfo}`}
	</El>
);

export default StockStatus;
